var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    width: 42.75,
    height: 17.516,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a2c"
    },
    d: "M12.07 3.855v3.032a2.192 2.192 0 0 0-1.836-.805 2.455 2.455 0 0 0-1.957.9 3.448 3.448 0 0 0-.77 2.338 3.544 3.544 0 0 0 .759 2.354 2.476 2.476 0 0 0 1.957.887 2.194 2.194 0 0 0 1.953-.987v.801h1.453v-8.52zm10.356 0V5.32h1.562V3.855Zm3.316 0v8.52h1.559v-8.52ZM18.18 6.033a2.953 2.953 0 0 0-.145.004 3.62 3.62 0 0 0-2.865 1.381l.982.898a5.519 5.519 0 0 1 .95-.767 1.8 1.8 0 0 1 .96-.229 1.274 1.274 0 0 1 .84.25.816.816 0 0 1 .31.686v.142l-1.439.266a4.655 4.655 0 0 0-1.978.73 1.68 1.68 0 0 0-.674 1.43 1.537 1.537 0 0 0 .602 1.301 2.63 2.63 0 0 0 1.6.453 2.279 2.279 0 0 0 1.98-.84v.637h1.4v-4.14l-.004-.003a1.984 1.984 0 0 0-.693-1.603 2.953 2.953 0 0 0-1.826-.596Zm13.582.006a3.109 3.109 0 0 0-2.127.91 3.223 3.223 0 0 0-.889 2.358 3.257 3.257 0 0 0 .889 2.363 3.127 3.127 0 0 0 2.299.898 3.075 3.075 0 0 0 2.28-.898 3.236 3.236 0 0 0 .901-2.363 3.2 3.2 0 0 0-.9-2.358 3.057 3.057 0 0 0-2.281-.91 3.109 3.109 0 0 0-.172 0zm-9.336.203v6.133h1.562V6.242Zm9.406 1.117a1.449 1.449 0 0 1 .102 0 1.4 1.4 0 0 1 1.152.54 2.458 2.458 0 0 1 0 2.822 1.416 1.416 0 0 1-1.152.525 1.462 1.462 0 0 1-1.176-.525 2.161 2.161 0 0 1-.434-1.414 2.149 2.149 0 0 1 .434-1.409 1.449 1.449 0 0 1 1.074-.539zm-21.334.07a1.327 1.327 0 0 1 .098 0 1.345 1.345 0 0 1 1.1.516 2.033 2.033 0 0 1 .433 1.371h.002a2.1 2.1 0 0 1-.436 1.38 1.382 1.382 0 0 1-1.113.515 1.326 1.326 0 0 1-1.094-.516 2.225 2.225 0 0 1-.392-1.379 2.129 2.129 0 0 1 .406-1.37 1.327 1.327 0 0 1 .996-.516Zm8.717 2.09v.36l.002.002a1.316 1.316 0 0 1-.453 1.082 1.813 1.813 0 0 1-1.176.369 1.358 1.358 0 0 1-.701-.154.54.54 0 0 1-.239-.457.645.645 0 0 1 .348-.586 4.22 4.22 0 0 1 1.188-.4l1.03-.215z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    width: 41.25,
    height: 16.016,
    x: 0.75,
    y: 0.75,
    ry: 8.008
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93b636c4c82cd3ba2732ed5660593225.svg";
export { ForwardRef as ReactComponent };